export default [
  {
    path: '/resources/thermowells',
    name: 'ThermowellSelection',
    component: () => import('../views/ThermowellSelection.vue')
  }
]
